/*
*   File:           useCsvValidation
*   Description:    Reuse stateful logic between components in Trusted Community, Gateway, Email Groups, and Admin Users.
*                   to validate addresses/domains inside csv files.      
*/
import { useState } from "react";
import { findInvalidAddress } from "src/common/helpers/utility";

export function useCsvDataValidation(collection: string[] = []) {
  const [valid_addresses, setValidAddresses] = useState<string[]>([]);
  const [invalid_addresses, setInValidAddresses] = useState<string[]>([]);
  const [duplicate_addresses, setDuplicateAddresses] = useState<string[]>([]);
  const [is_data_drop, setIsDataDrop] = useState<boolean>(false);

  function handleValidateData(csv_data: string[]) {
    let valid_addresses: string[];
    const invalid_data_found = findInvalidAddress(csv_data);
    const duplicates_data_found = collection.filter(function (this: any, address: string) {
      return this.has(address);
    }, new Set(csv_data));
  
    // if any duplicates or invalid addresses/domains found we need to filter out the valid ones
    if (duplicates_data_found.length >= 1 || invalid_data_found.length >= 1) {
      const merged_invalid_collections = new Set([...duplicates_data_found, ...invalid_data_found]);
      valid_addresses = csv_data.filter((address) => !merged_invalid_collections.has(address));
    } else {
      // if no duplicates or invalid found.
      valid_addresses = csv_data;
    }
    // data_drop_state: so we stop rendering the Draggable component. If the CSV file was already dragged/loaded into the component
    // then we unmount Draggable component from the tree and render the list of addresses.
    const data_drop_state = !(valid_addresses.length === 0 && invalid_data_found.length === 0 && duplicates_data_found.length === 0);

    setValidAddresses(valid_addresses);
    setInValidAddresses(invalid_data_found);
    setDuplicateAddresses(duplicates_data_found);
    setIsDataDrop(data_drop_state);
  }

  function resetData() {
    setValidAddresses([]);
    setInValidAddresses([]);
    setDuplicateAddresses([]);
    setIsDataDrop(false);
  }

  return {
    valid_addresses,
    invalid_addresses,
    duplicate_addresses,
    is_data_drop,
    handleValidateData,
    resetData
  };
};
